import api from "../../../libs/api";

angular
  .module("AccountingBoxApp")
  .controller("BankTransactionsCtrl", function(
    $scope,
    $rootScope,
    $location,
    $filter,
    $stateParams,
    $state,
    $timeout,
    BankTransaction,
    BankAccount,
    Sale,
    Purchase,
    Account,
    VatCode,
    SubAccount,
    LoopBackAuth,
    FileUploader,
    $window
  ) {
    var subAccounts;
    var datasource = {};
    var adapter = { remain: true };
    var loadedHttp = false;
    var vm = this;

    vm.export = function() {
      var data = vm.transactions || [];
      data = filteredDataMemoized($scope.order, data, $scope.unprocessed);
      data = data.map(function(t) {
        console.log(': t.dateFormattedShortNl', t.dateFormattedShortNl);
        return {
          Datum: t.dateFormattedShortNl,
          Bedrag: t.amountFormatted,
          Naam: t.accountName,
          Omschrijving: t.description,
          Rekening: t.accountNumber,
          Status: t.statusFormatted
        };
      });

      /* generate a worksheet */
      var ws = XLSX.utils.json_to_sheet(data, {dateNF:"dd-mm-yyyy"});

      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Banktransacties");

      var name =
        $rootScope.currentCompany.name +
        "-" +
        moment().format("YYYYMMDD") +
        "-bank-export.xlsx";

      XLSX.writeFile(wb, name);
    };

    vm.reloadAdapter = _.debounce(function(query) {
      if ($scope.adapter && $scope.adapter.isBOF()) {
        $scope.adapter.reload();
        scrolledToNextPage = false;
      }
    }, 250);

    let lastPosition = 0;
    let scrolledToNextPage = false;
    angular.element('#app-wrapper').on('scroll', function (e) {

      const isScrollingUp = e.target.scrollTop < lastPosition;
      if(e.target.scrollTop > 1000 && !scrolledToNextPage) {
        scrolledToNextPage = true;
      }
      if (isScrollingUp && e.target.scrollTop < 1000 && $scope.adapter.isBOF() && scrolledToNextPage) {
        vm.reloadAdapter();
      }

      lastPosition = e.target.scrollTop;

    // }
      // if($window.scrollY < 500) {
      // }
    });


    vm.datasource = datasource;
    vm.queryChanged = _.debounce(function() {
      queryChanged();
    }, 300);
    vm.itemsCount = 0;
    vm.reloadTable = function reloadTable() {
      // console.log('$scope.adapter',vm.adapter);
      if ($scope.adapter) {
        $scope.adapter.reload();
      }
    };
    $scope.$watch("adapter", function() {
      vm.reloadTable();
    });
    //set query based on url
    $scope.$watch(
      function() {
        return $location.url();
      },
      function(url) {
        if (url) {
          $scope.order.filter = $location.search().q;
          if($location.search().status === 'unprocessed') {
            $scope.unprocessed = true
          }
          $scope.bankTransactionId = $location.search().bankTransactionId;
        }
      }
    );

    $scope.check_for_reload = function() {

      console.log('checkfor reload');
      if (!last_descriptor) {
        return;
      }

      var new_first_item = -1;
      var max_loaded = last_descriptor.index + last_descriptor.count;

      if ($window.pageYOffset === 0) {
        // reset to zero
        new_first_item = 0;
      } else {

        var position = $window.pageYOffset;
        var perc_scrolled = last_descriptor.position / position;

        new_first_item = max_loaded * perc_scrolled;

      }

      // If we are skipping more than "n" items, reload
      if (max_loaded - new_first_item > 200) {
        $scope.uiScrollAdapter.reload(new_first_item);
      }


    };

    function queryChanged() {
      vm.reloadTable();
      var q = $scope.order.filter;
      var unprocessed = $scope.unprocessed
      if (q) {
        $location.search("q", $scope.order.filter);
      } else {
        $location.search("q", null);
      }
      if(unprocessed) {
        $location.search('status','unprocessed')
      }else {
        $location.search('status', undefined)
      }
    }

    $scope.order = {
      by: "date",
      reverse: true,
      filter: ""
    };
    $scope.limitList = 15;

    var uploadUrl = function() {
      var u =
        API_ENDPOINT +
        "/BankAccounts/" +
        $stateParams.id +
        "/uploadBankStatement";

      if (
        LoopBackAuth.currentUserData.isBookkeeper &&
        $rootScope.currentCompany
      ) {
        u = u + "?currentCompanyId=" + $rootScope.currentCompany.id;
      }
      return u;
    };

    var uploader = ($scope.uploader = new FileUploader({
      url: uploadUrl(),
      headers: {
        Authorization: LoopBackAuth.accessTokenId
      }
    }));
    uploader.onAfterAddingAll = function(addedFileItems) {
      uploader.uploadAll();
      console.info("onAfterAddingAll", addedFileItems);
    };

    uploader.onSuccessItem = function(fileItem, response, status, headers) {
      console.info("onSuccessItem", fileItem, response, status, headers);
      console.log("sucuess item upload", fileItem);
      loadBankTransactions();
    };
    uploader.onErrorItem = function(item, response, status, headers) {
      console.log("response:", response);
      window.swal("Mislukt", response.error.message, "error");
    };

    vm.uploader = uploader;

    var filteredDataMemoized = _.memoize(filteredData, function resolver() {
      return JSON.stringify(arguments);
    });

    function filteredData(order, result, unprocessed) {
      if(unprocessed) {
        result = result.filter(function(bt) {
          return bt.processed === false
        })
      }
      var options = {
        shouldSort: true,
        threshold: 0.05,
        location: 0,
        distance: 10000,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          "accountName",
          "accountNumber",
          "journalEntry.Lines.account.description",
          "journalEntry.Lines.account.accountNumber",
          "journalEntry.Lines.account.subCategory.description",
          "description",
          "batchReference",
          "endToEndIdentification",
          "invoices.invoiceNumber",
          "dateFormattedShort",
          "dateFormattedLong",
          "amountFormatted",
          "amountFormattedOriginal",
          "currencyAmountFormatted",
          "currencyAmountCurrencyFormattedOriginal",
          "statusFormatted"
        ]
      };
      if (order.filter && order.filter.length > 0) {
        var fuse = new Fuse(result, options); // "list" is the item array
        result = fuse.search(order.filter);
        result = result.map((t) => t.item);
      }
      result = $filter("orderBy")(result, order.by, order.reverse);
      return result;
    }

    datasource.get = function(index, count, success) {
      // console.log('data soruce get vm.transactions',vm.transactions.length);

      return $timeout(function() {
        var result = vm.transactions || [];
        // console.log('data soruce get',result.length);
        if (!loadedHttp) {
          result = [];
        }
        if($scope.bankTransactionId){
          result = result.filter(function(bt) {
            return bt.id === $scope.bankTransactionId
          })
        }
        result = filteredDataMemoized($scope.order, result, $scope.unprocessed);
        vm.itemsCount = result.length;
        return success(result.slice(index - 1, index - 1 + count));
      }, 0);
    };

    $rootScope.addMoreItems = function() {
      console.log("add items:");
      $scope.limitList += 10;
    };

    $scope.invoicesOrder = function() {
      return {
        by: ["checked", "dueDate"],
        reverse: true,
        filter: ""
      };
    };

    vm.loadInvoices = function() {
      if ($rootScope.isBookkeeper()) {
        var sFilter = {
          include: {
            relation: "customer",
            scope: {
              fields: {
                name: true,
                website: true
              }
            }
          },
          where: { or: [{status: "unpaid"}, {status: "partiallypaid"}] }
          // fields: [].concat(invoiceFields, "customer")
        };

        var sales = Sale.find({
          filter: sFilter
        });
        vm.sales = sales;
        var pFilter = {
          include: {
            relation: "vendor",
            scope: {
              fields: {
                name: true,
                website: true
              }
            }
          },
          where: { status: { neq: "paid" } }
          // fields: [].concat(invoiceFields, "vendor")
        };
        var purchases = Purchase.find({
          filter: pFilter
        });
        vm.purchases = purchases;
      }
    };

    vm.purchases = [];
    vm.sales = [];
    vm.transactions = [];

    var bankId = $stateParams.id;

    if ($state.params.bankAccount) {
      vm.bankAccount = $state.params.bankAccount;
    }
    // vm.bankAccount = BankAccount.get({
    //   id: $stateParams.id
    // });

    vm.autoImport = function() {
      BankAccount.autoImport({
        id: bankId
      });
    };

    vm.autoMatchLoading = false;
    vm.autoMatch = function() {
      vm.autoMatchLoading = true;
      BankAccount.autoMatch({
        id: bankId
      }).$promise.then(function() {
        vm.autoMatchLoading = false;
        console.log("matched banktransactions");
        loadBankTransactions();
      });
    };

    vm.cleanDescription = function(transaction) {
      let description = transaction.description
      description = description.replaceAll('NOTPROVIDED<br>', '').replaceAll('NOTPROVIDED\n','').replaceAll(/, NOT_?PROVIDED/gi,'')
      description = description.replaceAll(/ ([a-z]+?: ?)/gi, '\n$1')
      if (!description) {
        return [null, null];
      }
      const match = description.match(/(omschrijving: ?((?:\n|<br>|.)+?))(?:(?:\b.+):|$)/i)
      if (!match) {
        return [description, null];
      }
      return [match[2].trim(), description.replace(match[1], '')];
    }

    vm.openReference = function(id, type) {
      //            alert('invoice viewing' + id + ' ' + type);
      var to = type.toLowerCase() + "s";
      if (type.toLowerCase() === "journalentry") {
        to = "journalEntries";
      }
      $state.go("app.company.edit." + to, {
        id: id
      });
    };

    vm.abs = function(amount) {
      return Math.abs(amount)
    }

    vm.invoiceAmountDue = function(invoice, transaction, payingAmount) {
      //console.log('original invoices', originalInvoices);
      var amount = invoice.amountDue;
      if (transaction.originalInvoices) {
        // var index = originalInvoices.indexOf(invoice);
        var index = _.findIndex(transaction.originalInvoices, function(inv) {
          return inv.invoiceId === invoice.id;
        });

        if (index > -1) {
          //   console.log('origal amount payed',originalInvoices[index].paymentAmount);
          //     console.log('paying amount',payingAmount);

          var amount =
            invoice.amountDue +
            transaction.originalInvoices[index].paymentAmount; //
          //  if(originalInvoices[index].paymentAmount!==payingAmount){
          //  amount+=payingAmount-originalInvoices[index].paymentAmount;
          //}

          //                     console.log('payment amount:', payingAmount);

          //      return amount;
        }
      }
      if (payingAmount) {
        amount -= payingAmount;
      }
      return roundTwoDecimals(amount);
    };

    vm.invoiceNumbers = function(transaction) {
      var str = "";

      if (transaction.invoices.length > 0) {
        transaction.invoices.forEach(function(invoice, index) {
          str +=
            '<div class="referenceLink" ng-click="bt.openReference(\'' +
            invoice.invoiceId +
            "','" +
            invoice.invoiceType +
            "')\">";
          if (index > 0) {
            //  str += ' - ';
          }
          str += "<a>";
          if (invoice.invoiceType === "Sale") {
            str += "V - ";
          }
          if (invoice.invoiceType === "Purchase") {
            str += "I - ";
          }
          str += invoice.invoiceNumber;
          str += "</a>";
          // if(invoice.matchingScore) {
          //   str += ' - ' + roundTwoDecimals(invoice.matchingScore * 100) + '%';
          // }
          str += "</div>";
        });
        //  console.log(str);
      }
      if (
        transaction.journalEntry &&
        transaction.journalEntry.Lines &&
        transaction.journalEntry.Lines.length > 0
      ) {
        transaction.journalEntry.Lines.forEach(function(line, index) {
          if (line.account) {
            str += '<div class="referenceLink description">';
            if ($rootScope.isBookkeeper()) {
              str += "GB - ";
              str += line.account.accountNumber;
              str += " - ";
            }
            str += line.account.description;
            str += "</div>";
          }
        });
      }

      if (str.length < 1) {
        str =
          "<span ng-class=\"isBookkeeper()? 'text-danger': 'description'\">Niet verwerkt</span></br>";
      }
      if ($rootScope.isBookkeeper()) {
        str += '<div class="description">';
        if (
          transaction.processingType === "INVOICE_MATCHING" &&
          transaction.invoices[0] && transaction.invoices[0].matchingScore
        ) {
          str += "(gematched ";
          str +=
            roundTwoDecimals(transaction.invoices[0].matchingScore * 100) +
            "%)";
        }
        if (transaction.processingType === "BANK_RULE") {
          str += "(bankregel)";
        }
        if (transaction.processingType === "AUTOMATIC_BOOKING") {
          str += "(automatische boeking)";
        }
        if (transaction.processingType === "BOOKKEEPER") {
          if ($rootScope.isBookkeeper() && transaction.user) {
            str += `(${transaction.user.name})`;
          }else {
            str += "(boekhouder)";
          }
        }
        str += "</div>";
      }

      if (transaction.journalEntry) {
        //  console.log('totalamount', transaction.journalEntry.Lines[0].amount);
      }
      return str;
    };

    vm.invoices = function(transaction) {
      if(transaction.invoices?.length> 0 && !transaction.payments) {
        return []
      }
      var invoices;
      //  console.log('invoices transaction:',transaction);
      if (transaction.menu === "purchases") {
        invoices = vm.purchases;
      } else {
        invoices = vm.sales;
      }
      var transactionInvoices = [];
      if (transaction && transaction.payments) {
        transactionInvoices = transaction.payments.map(function(payment) {
          return payment.invoice;
        });
      }

      invoices = transactionInvoices.concat(invoices);
      invoices = _.uniq(invoices, "id");
      // invoices = _.filter(invoices, function(invoice) {
      //   return (
      //     invoice.amountDue !== 0 || vm.indexOriginal(transaction, invoice) > -1
      //   );
      // });
      return invoices;
    };

    vm.invoices = _.memoize(vm.invoices, function resolver() {
      return JSON.stringify(arguments);
    });

    vm.originalInvoices = function(transaction) {
      // console.log('ORIGINAL INVOICES');
      transaction.originalInvoices = JSON.parse(
        JSON.stringify(transaction.invoices)
      );
    };

    vm.getConnectedPayments = async function(transaction) {
      const payments = await api.get(`/BankTransactions/${transaction.id}/payments`, {
        params: {
          filter: {
            include: {
              relation: "invoice",
              scope: {
                // fields: { Lines: false },
                include: [
                  {
                    relation: "vendor",
                    scope: {
                      fields: {
                        name: true,
                        website: true
                      }
                    }
                  },
                  {
                    relation: "customer",
                    scope: {
                      fields: {
                        name: true,
                        website: true
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      })
      transaction.payments = payments;
      $scope.$digest()
      console.log('payments',payments);
    }

    vm.toggleInvoices = function(transaction) {
      vm.getConnectedPayments(transaction);
      transaction.showInvoices = !transaction.showInvoices;
      if ($rootScope.isBookkeeper()) {
        initializeJE(transaction);
        // console.log('transactoin amount:', transaction.amount);
        if (transaction.amount < 0) {
          transaction.menu = "purchases";
        } else {
          transaction.menu = "sales";
        }
        if(transaction.journalEntry && transaction.journalEntry.Lines.length > 0 && transaction.journalEntry.Lines[0].amount !== 0) {
          transaction.menu = 'journalEntry'
        }
      }
      //  transaction.
    };
    vm.removeModal = function(transaction) {
      transaction.remove();
    };

    var transactionToDelete = null;

    vm.removeModal = function(transaction) {
      $("#removeModal").appendTo("#app-content");
      $("#removeModal").modal("show");
      transactionToDelete = transaction;
    };

    vm.remove = function() {
      $("#removeModal").modal("hide");
      BankTransaction.deleteById({
        id: transactionToDelete.id
      }).$promise.then(function() {
        transactionToDelete = null;
        console.log("deleted to banktransaction");
        loadBankTransactions();
      });
    };

    vm.saving = false;

    vm.save = async function(transaction) {
      console.log('transaction save',transaction);
      //    if(!(transaction.journalEntry&&transaction.journalEntry.Lines.length>0&&transaction.journalEntry.Lines[0].account)){
      // transaction.journalEntry.Lines =[];
      //  }
      //
      if(vm.saving) {
        return false;
      }
      vm.saving = true;
      // var payments = transaction.payments;
      try {
        const savedTransaction = await api.patch(`/BankTransactions/${transaction.id}`, angular.toJson(transaction))
        console.log('transaction saved',savedTransaction);
        // transaction.payments = payments;
        savedTransaction.originalInvoices = JSON.parse(
          JSON.stringify(transaction.invoices)
        );
        transaction.showInvoices = false;
        transaction.invoices = savedTransaction.invoices;
        transaction.userId = LoopBackAuth.currentUserData?.id;
        transaction.user = LoopBackAuth.currentUserData;
        transaction.payments = savedTransaction.payments || undefined;
        transaction.processingType = savedTransaction.processingType;
        transaction.unprocessed = savedTransaction.unprocessed;
        transaction.status = savedTransaction.status;
        setTransactionStatus(transaction);
        vm.saving = false;
        vm.getConnectedPayments(savedTransaction);
        vm.loadInvoices();
      } catch(e) {
        window.swal("Opslaan mislukt", e.data?.error?.message || e.message, "error", "error");
        vm.saving = false;
      }
    };

    vm.saveDisabled = function(transaction) {
      if(vm.saving) {
        return false;
      }
      // console.log('amount due', vm.amountDue(transaction));
      var amountDue = vm.amountDue(transaction);
      if (
        (Math.abs(amountDue) >= 0 && Math.abs(amountDue) <= 0.05) ||
        (transaction.invoices.length == 0 &&
          !transaction.journalEntry.Lines[0].account)
      ) {
        return false;
      } else {
        return true;
      }
    };
    vm.amountDue = function(transaction) {
      var amount = 0;
      _.each(transaction.invoices, function(invoice, index) {
        var a = invoice.paymentAmount;
        if (invoice.invoiceType === "Purchase") {
          a = a * -1;
        }
        amount += roundTwoDecimals(a);
      });
      amount += vm.purchaseGrandTotal(transaction);
      return roundTwoDecimals(transaction.amount - amount);
    };

    vm.toggleInvoice = function(transaction, invoice) {
      if (transaction.invoices === undefined) transaction.invoices = [];
      var index = vm.index(transaction, invoice);
      if (transaction.invoices[index]) {
        transaction.invoices.splice(index, 1);
      } else {
        // console.log(transaction, invoice);
        // line.invoices[transaction.id]=transaction.totalAmount;
        //line.invoices[transaction.id] = transaction.totalAmount;
        var invoiceType = "";
        if (transaction.menu === "purchases") {
          invoiceType = "Purchase";
        } else {
          invoiceType = "Sale";
        }
        transaction.invoices.push({
          invoiceId: invoice.id,
          invoiceType: invoiceType,
          invoiceNumber: invoice.invoiceNumber,
          paymentAmount: vm.invoiceAmountDue(invoice, transaction, 0)
        });
      }
      invoice.checked = vm.checked(transaction, invoice);
      // console.log(transaction.invoices);
    };

    vm.index = function(transaction, invoice) {
      return _.findIndex(transaction.invoices, function(inv, index) {
        if (inv.invoiceId == invoice.id) {
          return true;
        }
      });
    };
    vm.indexOriginal = function(transaction, invoice) {
      return _.findIndex(transaction.originalInvoices, function(inv, index) {
        if (inv.invoiceId === invoice.id) {
          return true;
        }
      });
    };
    vm.checked = function(transaction, invoice) {
      var index = vm.index(transaction, invoice);
      if (index > -1) {
        return true;
      } else {
        return false;
      }
    };
    vm.company = function(invoice) {
      if (invoice.customer) return invoice.customer;
      else return invoice.vendor;
    };

    vm.year = $rootScope.defaultDisplayYear;
    vm.yearChanged = function() {
      loadBankTransactions();
      vm.loadInvoices();
    };

    async function loadBankTransactions() {
      console.log('loadBankTransactions',$stateParams.id);
      BankAccount.get(
        {
          id: $stateParams.id
        },
        function(bankAccount) {
          vm.bankAccount = bankAccount;
        }
      );
      var filter = {
        where: {
          bankAccountId: bankId
        },
        // include: [
        //   {
        //     relation: "user",
        //     scope: {
        //       fields: {
        //         id: true,
        //         name: true
        //       }
        //     }
        //   },
        //   {
        //     relation: "payments",
        //     scope: {
        //       include: {
        //         relation: "invoice",
        //         scope: {
        //           // fields: { Lines: false },
        //           include: [
        //             {
        //               relation: "vendor",
        //               scope: {
        //                 fields: {
        //                   name: true,
        //                   website: true
        //                 }
        //               }
        //             },
        //             {
        //               relation: "customer",
        //               scope: {
        //                 fields: {
        //                   name: true,
        //                   website: true
        //                 }
        //               }
        //             }
        //           ]
        //         }
        //       }
        //     }
        //   }
        // ]
      };
      var dateFilter = $rootScope.displayDateFilter(vm.year);
      if (dateFilter) {
        filter.where.date = dateFilter;
      }

      vm.loading = true;

      try {
        const data =  await api.get(`/BankTransactions/find`, {
          params: {
            dateGte: dateFilter?.gte,
            dateLte: dateFilter?.lte,
            bankAccountIds: [$stateParams.id],
          }
        })
        vm.transactions = data;
      }catch (e) {
        console.error('error loading transactions',e);
      }finally {
        vm.loading = false;
      }

      // vm.transactions = BankTransaction.find(
      //   {
      //     filter: filter
      //   },
      //   function() {
          moment.locale('nl');
          vm.loading = false;
          loadedHttp = true;
          vm.transactions = vm.transactions.map(function(i) {
            i.dateFormattedShort = moment(i.date).format("L");
            i.dateFormattedShortNl = moment(i.date).format("DD-MM-YYYY");
            i.dateFormattedLong = moment(i.date).format("LL");
            i.amountFormatted = $filter("currency")(i.amount, "NONE", 2);
            i.amountFormattedOriginal = roundTwoDecimals(i.amount).toFixed(2);
            i.currencyAmountFormatted = $filter("currency")(i.currencyAmount || i.amount , "NONE", 2);
            i.currencyAmountFormattedOriginal = roundTwoDecimals(i.currencyAmount || i.amount).toFixed(2);

            return i;
          });

          setTransactionsStatus();
          console.log('receivedf transactions',vm.transactions.length);

          vm.reloadTable();
        // }
      // );
    }

    loadBankTransactions();
    vm.loadInvoices();

    function setTransactionStatus(transaction) {
      // if (isProcessed(transaction)) {
      // var amountDue = vm.amountDue(transaction);
      // if (Math.abs(amountDue) >= 0 && Math.abs(amountDue) < 0.01) {
      //   transaction.statusFormatted = "Verwerkt";
      //   transaction.status = "processed";
      // } else {
      //   transaction.statusFormatted = "Niet verwerkt";
      //   transaction.status = "unprocessed";
      // }
      if (transaction.processed) {
        transaction.statusFormatted = "Verwerkt";
        transaction.status = "processed";
      } else {
        transaction.statusFormatted = "Niet verwerkt";
        transaction.status = "unprocessed";
      }
      if (transaction.processingType === "BOOKKEEPER") {
        transaction.statusFormatted += " boekhouder";
        if ($rootScope.isBookkeeper() && transaction.user) {
          transaction.statusFormatted += ` ${transaction.user.name}`;
        }
      }
    }
    function setTransactionsStatus() {
      vm.transactions.forEach(function(transaction) {
        setTransactionStatus(transaction)
      });
    }

    function isProcessed(transaction) {
      return (
        transaction.invoices.length > 0 ||
        (transaction.journalEntry &&
          transaction.journalEntry.Lines &&
          transaction.journalEntry.Lines.length > 0)
      );
    }

    vm.refreshSubAccounts = function() {
      SubAccount.find(function(subA) {
        // vm.subAccounts=subA;
        subAccounts = subA;
      });
    };

    if ($rootScope.isBookkeeper()) {
      setTimeout(function() {
        vm.accounts = Account.findApplicable();
        vm.vatCodes = VatCode.find({
          filter: {
            where: {
              or: [{ sale: true }, { purchase: true }]
            }
          }
        });
        vm.refreshSubAccounts();
      }, 1000);
    }

    vm.subAccounts = function(item) {
      if (item && item.account) {
        var aN = item.account.accountNumber;
        var subAccountType = vm.subAccountType(item);
        return _.filter(subAccounts, function(a) {
          return a.type === subAccountType;
        });
      } else {
        return subAccounts;
      }
    };

    vm.subAccountType = function(item) {
      var aN = 0;
      if (item && item.account) {
        aN = item.account.accountNumber;
      }
      if (
        (aN >= 213000 && aN <= 213030) ||
        aN == 4102070 ||
        aN == 4106070 ||
        (aN >= 4205000 && aN <= 4205990)
      ) {
        return "VEHICLE";
      } else if (
        (aN >= 509000 && aN <= 509080) ||
        aN == 1103140 ||
        aN == 1103120 ||
        aN == 1209010 ||
        aN == 1209020 ||
        aN == 9005010 ||
        aN == 306010 ||
        aN == 806030 ||
        aN == 8401060 ||
        aN == 8401070 ||
        aN == 8404130 ||
        aN == 8404140 ||
        aN == 4203110
      ) {
        return "PARTNER";
      } else if (
        aN == 301010 ||
        aN == 305010 ||
        aN == 504070 ||
        aN == 8401010 ||
        aN == 8404080 ||
        aN == 8410010
      ) {
        return "PARTICIPATION";
      } else if (
        (aN >= 100000 && aN <= 218030) ||
        (aN >= 4100000 && aN <= 4199030)
      ) {
        return "INVESTMENT";
      } else {
        return "MISCELLANEOUS";
      }
    };

    /*$scope.newSubAccount = function (newTag) {
         console.log('newtag is:',newTag);
         var item = {
         description: newTag,
         type:''
         };

         return item;
         };*/
    vm.subAccountSelect = function(subAccount, item) {
      if (subAccount && subAccount.new) {
        SubAccount.create(subAccount, function(subAccount) {
          item.subAccount = subAccount;
          item.subAccountId = subAccount.id;
          SubAccount.find(function(subA) {
            subAccounts = subA;
          });
        });
      }else {
        item.subAccount = subAccount;
        item.subAccountId = (subAccount && subAccount.id) || null;
      }
    };

    vm.refreshSubAccount = function(query, item) {
      subAccounts = $filter("propsFilter")(subAccounts, {
        description: query
      });
      if (subAccounts && subAccounts.length < 1 && query.length > 0) {
        subAccounts.push({
          description: query,
          new: true,
          type: vm.subAccountType(item)
        });
      }
    };

    vm.accountChanged = function(item) {
      var type = vm.subAccountType(item);
      // if (type !== 'MISCELLANEOUS') {
      //     if ((item.account.accountNumber >= 100000 && item.account.accountNumber <= 218030)) {
      //         /*if(!item.destination){
      //          item.destination={};
      //          }
      //          item.destination.numberOfMonths = 60;
      //          if(item.account.accountNumber===107010){
      //          item.destination.numberOfMonths = 120;
      //          }
      //          item.destination.residualValue = 0;*/
      //     } else {
      //         if (!item.subAccount) {
      //             item.subAccount = vm.subAccounts(item)[0];
      //         }
      //     }
      // }
    };

    vm.openJournalEntryMenu = function(transaction) {
      if (!transaction.journalEntry.Lines[0].description) {
        transaction.journalEntry.Lines[0].description = transaction.description;
      }
      if (!transaction.journalEntry.Lines[0].amount) {
        vm.calculateDefaultBookingAmount(transaction);
      }
    };

    vm.vatCodeChanged = function(line, transaction) {
      vm.calculateDefaultBookingAmount(transaction);
    };

    vm.calculateDefaultBookingAmount = function(transaction) {
      var numOfFiledLines = 0;
      angular.forEach(transaction.journalEntry.Lines, function(line, key) {
        if (Math.abs(line.amount) > 0) {
          numOfFiledLines += 1;
        }
      });
      if (numOfFiledLines < 2) {
        var line = transaction.journalEntry.Lines[0];
        transaction.journalEntry.Lines[0].amount = 0;
        if (line) {
          if (!line.vatCode || line.vatCode.secondAccount !== undefined) {
            transaction.journalEntry.Lines[0].amount = -roundTwoDecimals(
              vm.amountDue(transaction)
            );
          } else if (line.vatCode) {
            var transactionDate = moment(transaction.date);
            var percentage = $rootScope.getVatCodePercentage(
              line.vatCode,
              transactionDate
            );
            transaction.journalEntry.Lines[0].amount = -roundTwoDecimals(
              (vm.amountDue(transaction) / (percentage + 100)) * 100
            );
          }
        }
      }
    };

    function initializeJE(transaction) {
      if (!transaction.journalEntry) transaction.journalEntry = {};
      if (!transaction.journalEntry.Lines) {
        transaction.journalEntry.Lines = [];
        vm.addItem(transaction);
      }
      if (transaction.journalEntry.Lines.length < 1) {
        vm.addItem(transaction);
      }
    }

    vm.focus = function(index, transaction) {
      if (transaction.journalEntry.Lines.length - 1 === index) {
        vm.addItem(transaction);
      }
    };
    vm.addItem = function(transaction) {
      if (!transaction.journalEntry.Lines) {
        transaction.journalEntry.Lines = [];
      }
      transaction.journalEntry.Lines.push({
        description: transaction.journalEntry.description || "",
        amount: 0, //,
        invoice: []
        // vatCode: saleVATHigh
      });
    };

    vm.removeItem = function(item, transaction) {
      transaction.journalEntry.Lines.splice(
        transaction.journalEntry.Lines.indexOf(item),
        1
      );
      if (transaction.journalEntry.Lines.length === 0) {
        vm.addItem(transaction);
      }
    };

    function roundTwoDecimals(number) {
      return Math.round(number * 100) / 100;
    }

    vm.purchaseGrandTotal = function(transaction) {
      var total = 0;
      if (transaction.journalEntry && transaction.journalEntry.Lines) {
        angular.forEach(transaction.journalEntry.Lines, function(line, key) {
          total += line.amount + vm.calculateTax(line, transaction);
          if (line.vatCode && line.vatCode.secondAccount)
            total -= vm.calculateTax(line, transaction);
        });
      }
      return -total;
    };

    vm.calculateTax = function(line, transaction) {
      if (line.vatCode && line.vatCode.rates) {
        var journalDate = moment(transaction.date);
        return roundTwoDecimals(
          ($rootScope.getVatCodePercentage(line.vatCode, journalDate) *
            line.amount) /
            100
        );
      } else {
        return 0;
      }
    };

    vm.bankUrlShort = function() {
      return vm.bankUrl(true);
    };

    vm.bankUrl = function(short) {
      var link = "";
      var bankAccount = vm.bankAccount;
      if (!bankAccount) {
        return link;
      }
      var bN = bankAccount.bank?.name || '';
      var t = bankAccount.bankType;
      if (bN === "SNS Bank" && t === "private") {
        link = "https://www.snsbank.nl/mijnsns/secure/login.html";
      }
      if (bN === "SNS Bank" && t === "business") {
        link = "https://www.snsbank.nl/mijnsns/secure/loginzakelijk.html";
      }
      if (bN === "Rabobank") {
        link = "https://bankieren.rabobank.nl/klanten/";
      }
      if (bN === "ASN Bank" && t === "private") {
        link =
          "https://www.asnbank.nl/onlinebankieren/secure/loginparticulier.html";
      }
      if (bN === "ASN Bank" && t === "business") {
        link =
          "https://www.asnbank.nl/onlinebankieren/secure/loginzakelijk.html";
      }
      if (bN === "RegioBank" && t === "private") {
        link = "https://www.regiobank.nl/internetbankieren/secure/login.html";
      }
      if (bN === "RegioBank" && t === "business") {
        link =
          "https://www.regiobank.nl/internetbankieren/secure/loginzakelijk.html";
      }
      if (bN === "Knab") {
        link = "https://persoonlijk.knab.nl/account/inloggen";
      }
      if (bN === "Triodos Bank") {
        link = "https://bankieren.triodos.nl/ib-seam/login.seam";
      }
      if (bN === "Van Lanschot") {
        link = "https://login.vanlanschot.com/login";
      }
      if (bN === "Mollie") {
        link = "https://www.mollie.com/dashboard/login?";
      }
      if (bN === "Bunq") {
        link = "https://bunq.app/";
      }
      if (bN === "Moneyou") {
        link =
          "https://secure.moneyou.nl/cwsoft/policyenforcer/pages/loginB2C.jsf";
      }

      // if (LoopBackAuth.currentUserData.isBookkeeper) {
      if (bN === "ING" && t === "business") {
        link = "https://mijnzakelijk.ing.nl/login/";
      }
      if (bN === "ING" && t === "private") {
        link = "https://mijn.ing.nl/login/";
      }
      if (bN === "ABN AMRO" && t === "business") {
        link =
          "https://www.abnamro.nl/portalserver/mijn-abnamro-zakelijk/mijn-overzicht/overzicht/index.html";
      }
      if (bN === "ABN AMRO" && t === "private") {
        link =
          "https://www.abnamro.nl/portalserver/mijn-abnamro/mijn-overzicht/overzicht/index.html";
      }

      if (!link || link.length < 1) {
        return link;
      }

      if (short) {
        var regexp = /(?:\/|\.)([a-z]+\.[a-z]{2,3})(?:\/|$|\s)/;
        return link.match(regexp)[1];
      }
      return link;
    };
  });
